export default {
  name: 'App',
  components: {},

  mounted() {}

};